import {defineStore} from 'pinia';
import api from '~/api/developerIndex';
import {usePluginStoreStore} from '@/stores/plugin-store';

export const useDeveloperIndexStore = defineStore('developerIndex', {
  state: () => ({
    developersResponseData: null,
    developers: [],
  }),
  getters: {
    hasMore(state) {
      return (
        state.developersResponseData.currentPage <
        state.developersResponseData.total
      );
    },

    // getDeveloperIndexParams(state, getters, rootState) {
    getDeveloperIndexParams() {
      return (context) => {
        if (!context) {
          context = {};
        }

        const pluginStoreStore = usePluginStoreStore();
        const sortOptions = pluginStoreStore.sortOptions;
        const firstOptionKey = Object.keys(sortOptions)[0];

        const perPage = context.perPage ? context.perPage : null;
        const page = context.page ? context.page : 1;
        const orderBy = context.orderBy ? context.orderBy : firstOptionKey;
        const direction = context.direction
          ? context.direction
          : pluginStoreStore.sortOptions[firstOptionKey];

        return {
          perPage,
          page,
          orderBy,
          direction,
        };
      };
    },
  },
  actions: {
    cancelRequests() {
      return new Promise((resolve) => {
        api.cancelRequests();
        resolve();
      });
    },

    searchDevelopers(context) {
      return new Promise((resolve, reject) => {
        const developerIndexParams = this.getDeveloperIndexParams(context);

        api
          .searchDevelopers({
            searchQuery: context.searchQuery,
            developerIndexParams,
          })
          .then((response) => {
            if (response.data && response.data.error) {
              reject(response.data.error);
            }

            this.updateDeveloperIndex({context, response}).then(() => {
              resolve(response);
            });
          })
          .catch((thrown) => {
            if (thrown.response && thrown.response.data) {
              if (thrown.response.data.message) {
                reject(thrown.response.data.message);
              } else if (thrown.response.data.error) {
                reject(thrown.response.data.error);
              } else {
                reject(thrown.response.data);
              }
            } else {
              reject(thrown);
            }
          });
      });
    },

    updateDeveloperIndex({context, response}) {
      return new Promise((resolve) => {
        this.updateDevelopersResponseData(response);

        if (context.appendData && context.appendData === true) {
          this.appendDevelopers(response.data.developers);
          resolve();
        } else {
          setTimeout(function () {
            this.updateDevelopers(response.data.developers);
            resolve();
          }, 1);
        }
      });
    },

    updateDevelopers(developers) {
      this.developers = developers;
    },

    updateDevelopersResponseData(response) {
      this.developersResponseData = response.data;
    },

    appendDevelopers(developers) {
      this.developers = [...this.developers, ...developers];
    },
  },
});
